import { Component, Input, OnInit } from '@angular/core';
import { Email } from '@edassist/api';
import { TimezonePipe } from '@edassist-ui/timezone';
import * as moment from 'moment-timezone';

@Component({
	selector: 'ea-email',
	templateUrl: './email.component.html',
	styleUrls: ['./email.component.scss']
})
export class EmailComponent implements OnInit {
	@Input() email: Email;
	emailTimeZone: string;
	@Input() isAdminNotification: boolean;

	constructor(private readonly timezonePipe: TimezonePipe) {}

	ngOnInit(): void {
		this.emailTimeZone = this.timezonePipe.transform(
			new Date(this.email.dateSent),
			moment.tz.guess(),
			'z'
		);
	}
}
